import { Filter } from 'labstep-web/components/Filter/Menu/types';

export const filters = [Filter.deleted];
